import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useWeb3React } from "@web3-react/core";
import { Web3AuthNoModal } from "@web3auth/no-modal";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { WALLET_ADAPTERS, CHAIN_NAMESPACES } from "@web3auth/base";
import { OpenloginAdapter } from "@web3auth/openlogin-adapter";

import "../../../../splash_event.css";
import { updateLocation, signupLoading } from "../../../../../../../redux/App/actions";
import { setUserSignOn, setLoginWallet } from "../../../../../../../redux/Account/actions";
import {axiosInstance, encryptLoginData, getIndexerUserTokens} from "../../../../../../../utils";

import axios from "axios";
import $ from "jquery";

let current_user_id = 0;

export const TeddyRegisterForm = () => {
    const dispatch = useDispatch();
    const { page_loaded }= useSelector((state) => state.app);
    const { racerID, userID, accountAddress } = useSelector((state) => state.account);

    const { chainId, account } = useWeb3React();

    // if((racerID.length > 1)&&(accountAddress.length > 1)) {
    //     //
    // }

    const [pageSet, setPage] = useState(false);
    const [web3auth, setWeb3auth] = useState(null);
    const [provider, setProvider] = useState(null);
    const [loggedIn, setLoggedIn] = useState(false);
    const [email, setEmail] = useState("");

    const [lineupFirstHTML,setLineupFirstHTML] = useState([]);
    const [lineupLastHTML,setLineupLastHTML] = useState([]);
    const [firstpickname,setFirstPickName] = useState('');
    const [firstpickphoto,setFirstPickPhoto] = useState('');
    const [firstpickpoints,setFirstPickPoints] = useState('0');
    const [firstpickodds,setFirstPickOdds] = useState('20');
    const [lastpickname,setLastPickName] = useState('');
    const [lastpickphoto,setLastPickPhoto] = useState('');
    const [lastpickpoints,setLastPickPoints] = useState('0');
    const [lastpickodds,setLastPickOdds] = useState('20');

    /* EXR Event ID */
    /* EXR Event ID */
    var exreventid = 2;
    let signup_user_id = 0;

    function validateEmailText(emailtext) {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (emailtext.match(validRegex)) {
          return 'pass';
        } else {
          return 'fail';
        }
    }

    function sendEventEmailCode() {
        var raceremail = document.getElementById("racerEmailAddress").value.trim();

        var addData = new Object();
        addData.specEmail = encodeURIComponent(raceremail);

        if(raceremail.length < 3) {
            alert('Add a Valid Email Address');
        } else if (validateEmailText(raceremail) == 'fail') {
            alert('Add a Valid Email Address');
        } else {
            $("#email-send-button").hide();
            $("#email-sent-loading").show();
            if(userID > 100000000) {
                showEmailLoggedIn();
                console.log('Logged In');
                // Create or Get Web3Auth Info
                //loginWeb3Auth(raceremail);
            } else {
                axiosInstance.post('member/event_email_add/',addData).then(result => {
                    if(Object.keys(result.data).length > 0) {
                        var save_result = result.data;
                        if(save_result.length > 0) {
                            //console.log('Email Data Added');
                            showEmailSendSent();
                        } else {
                            //console.log('No Email Data Found');
                            showEmailSendReset();
                            alert('Whoops! Something Went Wrong. Update and Try Again');
                        }
                        // Create or Get Web3Auth Info
                        //loginWeb3Auth(raceremail);
                    } else {
                        //console.log('Email Add No Data');
                        showEmailSendReset();
                        alert('Something Went Wrong. Update and Try Again.');
                    }
                }).catch(error => {
                    showEmailSendReset();
                    alert('Oh No! Something Went Wrong. Update and Try Again.');
                    console.log(error);
                });
            }
        }
    }

    function checkEventEmailCode() {
        var raceremail = document.getElementById("racerEmailAddress").value.trim();
        var racercode = document.getElementById("racerEmailCode").value.trim();
        
        var addData = new Object();
        addData.specEmail = encodeURIComponent(raceremail);
        addData.specCode = encodeURIComponent(racercode);
        addData.specEvent = encodeURIComponent(exreventid);

        if(raceremail.length <= 3) {
            alert('Add a Valid Email Address');
        } else if (validateEmailText(raceremail) == 'fail') {
            alert('Add a Valid Email Address');
        } else if (racercode.length != 6) {
            alert('Add a Valid Email Code');
        } else {
            $("#code-send-button").hide();
            $("#code-confirmed-loading").show();
            axiosInstance.post('member/event_email_code_check/',addData).then(result => {
                if(Object.keys(result.data).length > 0) {
                    var save_result = result.data;
                    if(save_result.length > 0) {
                        if(save_result[0]['status'] == 'expired') {
                            showEmailCodeReset();
                            alert('Your Confirmation Code Expired. Click Resend Code to Get a New Code.');
                            //console.log('Your Confirmation Code Expired. Click Resend Code to Get a New Code.');
                        } else if(save_result[0]['status'] == 'pending') {
                            showEmailCodeReset();
                            alert('Invalid Code. Check Your Code and Enter it Again');
                            //console.log('Invalid Code. Check Your Code and Enter it Again');
                        } else if (save_result[0]['status'] == 'approved_waitroom') {
                            // New User - Add to Users Table
                            addSpectatorInfo();

                        } else {
                            // Existing User - Approve Code
                            let userid = save_result[0]['user_id'];
                            let racerid = save_result[0]['racer_id'];
                            let spectatorid = save_result[0]['spectator_id'];
                            let logintime = save_result[0]['time'];
                            let logintoken = save_result[0]['token'];
                            // let logintimehash = save_result[0]['time_hash'];
                            // let hashed_time = encryptLoginData('login',logintime.toString());

                            // Login to Site
                            current_user_id = userid;
                            signup_user_id = userid;
                            dispatch(setUserSignOn(userid,racerid,spectatorid,logintoken,logintime));

                            // Existing User - Approve Code
                            showEmailCodeApproved();
                            
                            // Create or Get Web3Auth Info
                            //loginWeb3Auth(raceremail);
                        }
                    } else {
                        showEmailCodeReset();
                        alert('Whoops! Something Went Wrong. Update and Try Again');
                        //console.log('Whoops! Something Went Wrong. Update and Try Again');
                    }
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    function addSpectatorInfo() {
        var raceremail = document.getElementById("racerEmailAddress").value.trim();
        var racerhandle = '';
        var racertwitter = ''
        var racerdiscord = ''
        var addData = new Object();
        addData.specEmail = encodeURIComponent(raceremail);
        addData.specHandle = encodeURIComponent(racerhandle);
        addData.specTwitter = encodeURIComponent(racertwitter);
        addData.specDiscord = encodeURIComponent(racerdiscord);
        addData.specSource = 'event';
        addData.specEvent = encodeURIComponent(exreventid);

        axiosInstance.post('member/waitroom_spectator_add/',addData).then(result => {
            if(Object.keys(result.data).length > 0) {
                var save_result = result.data;
                if(save_result.length > 0) {
                    let userid = save_result[0]['user_id'];
                    let racerid = save_result[0]['racer_id'];
                    let spectatorid = save_result[0]['spectator_id'];
                    let logintime = save_result[0]['time'];
                    let logintoken = save_result[0]['token'];
                    // let logintimehash = save_result[0]['time_hash'];
                    // let hashed_time = encryptLoginData('login',logintime.toString());

                    // Login to Site
                    current_user_id = userid;
                    signup_user_id = userid;
                    dispatch(setUserSignOn(userid,racerid,spectatorid,logintoken,logintime));
                    
                    // New User Added - Approve Code
                    showEmailCodeApproved();

                    // Create or Get Web3Auth Info
                    //loginWeb3Auth(raceremail);

                } else {
                    showEmailCodeReset();
                    alert('Whoops! Something Went Wrong. Update and Try Again');
                }
            }
        }).catch(error => {
            console.log(error);
        });
    }

    function showRacewayPage() {
        window.location.href="/#/raceway";
    }

    function showEmailSendSent() {
        setTimeout(function(){
            $("#email-send-button").hide();
            $("#email-sent-loading").hide();
            $("#email-sent-button").show();
            $("#email-code-form").slideDown();
        },3000);
    }

    function showEmailSendReset() {
        $("#email-send-button").show();
        $("#email-sent-loading").hide();
        $("#email-sent-button").hide();
    }

    function showEmailLoggedIn() {
        setTimeout(function(){
            $("#email-send-button").hide();
            $("#email-sent-loading").hide();
            $("#code-confirmed-button-login").show();
        },3000);
    }

    function showEmailCodeApproved() {
        setTimeout(function(){
            $("#code-send-button").hide();
            $("#code-confirmed-loading").hide();
            $("#code-confirmed-button").show();
        },3000);
    }

    function showEmailCodeReset() {
        $("#code-send-button").show();
        $("#code-confirmed-loading").hide();
        $("#code-confirmed-button").hide();
    }

    if(pageSet === false) {
        setPage(true);
    }

    window.addEventListener("hashchange",
    function(){ 
        window.location.reload(); 
    }, false);

    return(<>
            <div className="row"  style={{marginTop:'50px',marginBottom:'0px',padding:'0px 20px'}}>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="headline-text event-register-large-headline" style={{fontSize:'30px'}}>
                                REGISTER FOR TOURNAMENT
                            </div>
                        </div>
                        <div className="col s12 m10 offset-m1">
                            <div className="subheadline-text grey-text event-register-subheadline">
                                EMAIL RSVP&nbsp;&nbsp;<span className="white-text">+</span>&nbsp;
                                DONATE TO UNLOCK PRIZES&nbsp;&nbsp;<span className="white-text">+</span>&nbsp;
                                LIVE STREAM 
                            </div>
                        </div>
                    </div>
                    <div className="row white-text" id="email-address-form" style={{marginTop:'30px',padding:'0px 20px'}}>
                        <div className="col s12 m10 offset-m1">
                            <span className="left headline-text event-register-formheader" 
                                style={{width:'100%'}} title="Register For Exiled Racers">
                                ENTER EMAIL ADDRESS
                            </span>
                        </div>
                        <div className="col s12 m6 offset-m1 l4 offset-l1" style={{marginBottom:'20px'}}>
                            <span className="left" style={{width:'100%',fontSize:'20px',lineHeight:'1em !important',height:'calc(1em + 10px)'}} title="Enter Email Address to Register">
                                <input id="racerEmailAddress" className="black-bubble-input-dark" 
                                    style={{width:'100%',fontSize:'20px',borderColor:'black'}} />
                            </span>
                        </div>
                        <div className="col s12 m4 l6">
                            <span id="email-send-button" className="round-border-button event-register-formbutton2 grey black-text left" 
                                style={{width:'auto',borderRadius:'5px',border:'0px'}} 
                                title="Register For Exiled Racers" onClick={()=>sendEventEmailCode()}>
                                <span className="left" style={{margin:"6px 5px 0px 5px"}}>SUBMIT</span>
                            </span>
                            <span id="email-sent-loading" className="preloader-wrapper small active event-register-formbutton2 left" 
                                style={{display:'none',height:'30px',width:'30px',marginTop:'3px'}}>
                                <div className="spinner-layer spinner-yellow-only">
                                    <div className="circle-clipper left">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            </span>
                            <span id="email-sent-button" className="round-border-button-green event-register-formbutton2 grey-text" 
                                style={{display:'none',width:'auto',borderRadius:'5px',border:'2px solid grey'}} title="Email Code Sent">
                                <span className="left" style={{margin:"5px"}}>EMAIL CODE SENT</span>
                            </span>
                            <span id="code-confirmed-button-login" className="round-border-button-green event-register-formbutton2" 
                                style={{display:'none',width:'auto',borderRadius:'5px',border:'2px solid #AAE167'}} title="REGISTERED FOR EVENT">
                                <span className="left" style={{margin:"5px"}}>REGISTERED!</span>
                            </span>
                        </div>
                    </div>
                    <div className="row white-text" id="email-code-form" style={{display:'none',marginTop:'20px',padding:'0px 20px'}}>
                        <div className="col s12 m10 offset-m1">
                            <span className="left headline-text event-register-formheader" title="Register For Exiled Racers">
                                ENTER EMAIL CODE
                            </span>
                        </div>
                        <div className="col s12 m6 offset-m1 l4 offset-l1" style={{marginBottom:'20px'}}>
                            <span className="left" style={{width:'100%',fontSize:'20px',lineHeight:'1em !important',height:'calc(1em + 10px)'}} 
                                title="Enter Email Confirmation to Complete Registering">
                                <input id="racerEmailCode" className="black-bubble-input-dark" style={{width:'100%',fontSize:'20px'}} />
                            </span>
                        </div>
                        <div className="col s12 m4 l6">
                            <span id="code-send-button" className="round-border-button event-register-formbutton2 grey black-text left" 
                                style={{width:'auto',borderRadius:'5px',border:'0px'}} 
                                title="Register For Exiled Racers" onClick={()=>checkEventEmailCode()}>
                                <span className="left" style={{margin:"6px 5px 0px 5px"}}>SUBMIT</span>
                            </span>
                            <span id="code-confirmed-loading" className="preloader-wrapper small active event-register-formbutton2 left" 
                                style={{display:'none',height:'30px',width:'30px',marginTop:'3px'}}>
                                <div className="spinner-layer spinner-yellow-only">
                                    <div className="circle-clipper left">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            </span>
                            <span id="code-confirmed-button" className="round-border-button-green event-register-formbutton2" 
                                style={{display:'none',width:'auto',borderRadius:'5px',border:'2px solid #AAE167'}} title="REGISTERED FOR EVENT">
                                <span className="left" style={{margin:"5px"}}>REGISTERED!</span>
                            </span>
                        </div>
                    </div>
    </>);
};